import { Draft } from "immer";

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { NewsListFilterState } from "@tCentro/Store/Components/NewsListFilter/NewsListFilterState";

const initialNewsFilterState: NewsListFilterState = {
    categoryFilters: [],
    brandFilters: [],
    announcementFilters: [],
};

const reducer = {
    "Components/NewsListFilter/SetNewsFilterIds": (
        draft: Draft<NewsListFilterState>,
        action: { categoryFilters: string[]; brandFilters: string[]; announcementFilters: string[]; },
    ) => {
        draft.categoryFilters = action.categoryFilters;
        draft.brandFilters = action.brandFilters;
        draft.announcementFilters = action.announcementFilters;
    },
};

export default createTypedReducerWithImmer(initialNewsFilterState, reducer);
